import { createBEM } from "@/libs";
import { AutoCenter, DotLoading } from "antd-mobile";
import { PropsWithChildren } from "react";
import { Empty } from "../Empty";
import "./index.scss";

const b = createBEM("i-ahooks-infinite-scroll-frame");
export const AhooksInfiniteScrollFrame = ({
  children,
  data,
  loading,
  loadingMore,
  noMore,
}: PropsWithChildren<{
  data?: {
    list: any[];
    total: number;
  };
  loading: boolean;
  loadingMore: boolean;
  noMore: boolean;
}>) => {
  return (
    <>
      {data?.list.length === 0 && noMore ? (
        <Empty></Empty>
      ) : (
        <>
          {children}
          <AutoCenter>
            {loading && (
              <div className={b()}>
                <span>加载列表中</span>
                <DotLoading />
              </div>
            )}
            {loadingMore && (
              <div className={b()}>
                <span>加载列更多数据中</span>
                <DotLoading />
              </div>
            )}
            {!loading && noMore && (
              <div className={b()}>
                <span>没有更多了</span>
              </div>
            )}
          </AutoCenter>
        </>
      )}
    </>
  );
};
